import { toast, TypeOptions, Flip } from "react-toastify";

export class Toast {
  show(message: string, type: TypeOptions = toast.TYPE.DEFAULT): void {
    toast(message, {
      position: toast.POSITION.TOP_RIGHT,
      autoClose: 5500,
      closeOnClick: false,
      hideProgressBar: true,
      pauseOnHover: true,
      draggable: false,
      type,
      transition: Flip,
    });
  }

  showInfo(message: string): void {
    this.show(message, toast.TYPE.INFO);
  }

  showSuccess(message: string): void {
    this.show(message, toast.TYPE.SUCCESS);
  }

  showWarning(message: string): void {
    this.show(message, toast.TYPE.WARNING);
  }

  showError(message: string): void {
    this.show(message, toast.TYPE.ERROR);
  }
}
